"use strict";
import { isBetaEnv, isProdEnv } from "utilities/src/environment";
function isAppUniswapOrg({ hostname }) {
  return hostname === "app.futurehost.xyz";
}
export function isAppUniswapStagingOrg({ hostname }) {
  return hostname.includes("staging") || hostname.includes("stg");
}
export function isBrowserRouterEnabled() {
  if (isProdEnv()) {
    if (isAppUniswapOrg(window.location) || isAppUniswapStagingOrg(window.location) || isLocalhost(window.location)) {
      return true;
    }
    return true;
  }
  return true;
}
export function isLocalhost({ hostname }) {
  return hostname === "localhost";
}
export function isRemoteReportingEnabled() {
  if (isBetaEnv() && !isAppUniswapStagingOrg(window.location)) {
    return false;
  }
  if (isProdEnv() && !isAppUniswapOrg(window.location)) {
    return false;
  }
  return false;
}
